var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"inner"},[_c('el-row',{staticClass:"onlyMobile"},[_c('el-col',[_c('h3',[_vm._v("Changelog")])])],1),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"changelog"},[(!_vm.loading)?_c('markdown-html'):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }